import {modifyAllRules} from "./validate";

/**
 * The document has finished loading and the document has been parsed
 * but sub-resources such as scripts, images, stylesheets and frames are still loading.
 *
 * @param callback
 */
export function ready(callback) {
    (document.readyState !== 'loading') ? callback() : document.addEventListener('DOMContentLoaded', callback);
}

/**
 * Function simplifies usage of the forEach loop of objects
 *
 * @param object
 * @param callback
 * @param scope
 */
export function forEach(object, callback, scope) {
    Object.entries(object).forEach(entry => {
        const [key, value] = entry;
        callback.call(scope, key, value);
    });
}

/**
 * Performs a fetch request to the specified uri using the provided method and parameters.
 *
 * @param {string} uri - The uri to request.
 * @param {string} method - The http method to use for the request.
 * @param {object} parameters - Additional parameters for the fetch request.
 * @param {function} [successCallback=()=>{}] - The function to call on successful fetch request.
 *
 * @returns {void}
 */
export function callFetch(uri, method, parameters, successCallback = () => {}) {
    let requestObject = { method: method, headers: parameters.headers ?? {} };
    parameters.overlay?.classList?.remove('d-none');

    if (parameters.body !== undefined && method.toLowerCase() !== 'get') {
        requestObject.body = JSON.stringify(parameters.body);
    }

    fetch(uri, requestObject).then((response) => {
        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`);
        }

        return response.text();
    }).then((data) => {
        successCallback(data);
        setTimeout(() => parameters.overlay?.classList?.add('d-none'), 300);
    }).catch(error => {
        Fnc.notify('error', LANG_NOTIFY['error'], LANG_NOTIFY['error_occurred']);
        // if block without else
        if (APP_ENV === 'production') {
            Fnc.createServerLog(error.message, {
                exception_trace: error.stack.replace(/\n/g, ' ').replace(/  +/g, ' '),
                calledUrl: uri,
                method: method
            });
        }
        parameters.overlay?.classList?.add('d-none');
    });
}

/**
 * Helper function to hide and disable form fields.
 * @param {HTMLElement} form The form element
 */
export function hideAndDisableFormFields(form) {
    form.querySelectorAll('.select-collapse').forEach(field => {
        field.classList.add('hidden');
        field.querySelectorAll('input, select, textarea').forEach(input => {
            input.disabled = true;
        });
    });
}

/**
 * Helper function to parse json data from response string
 * @param {string} data Response string
 * @returns {Object}
 */
export function parseJsonData(data) {
    const jsonData = (data.match(/^\{.*?\}(?=<|$)/s) || [])[0]?.trim();
    return jsonData ? JSON.parse(jsonData) : null;
}


/**
 * Retrieves the form validation rules as a JavaScript object.
 * @param formElement The form element from which to retrieve validation rules.
 * @returns {*}
 */
export function getValidationRules(formElement) {
    let rulesJson = formElement.querySelector('[name="_rules"]');
    return modifyAllRules(JSON.parse(rulesJson !== null ? rulesJson.value : '{}'));
}
